import React from 'react'

import { Greetings } from '../components/graduation/Greetings';

export const GraduationPage = () => {
  return (
    <div>
        <Greetings />
    </div>
  )
}
